import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { addDoc, collection, doc } from "firebase/firestore";
import { db, auth } from "firebaseApp";
import { imageStudioActions } from "store/imageStudio";
import toast from "react-hot-toast";

export default function GenerateImageButton() {
  const uid = auth.currentUser?.uid;
  const dispatch = useDispatch();
  const imageStudioState = useSelector((state) => state.imageStudio);

  const handleGenerate = async () => {
    try {
      const images = imageStudioState.images.map((image) => {
        const { base64, ...other } = image;
        return other;
      });
      const payload = {
        uid,
        prompt: imageStudioState.prompt,
        images,
        ratio: imageStudioState.ratio,
        transparent: imageStudioState.transparent,
        generating: true,
        createdAt: new Date().getTime(),
        modelName: imageStudioState.model.name,
      };
      await addDoc(collection(db, "imageGeneration"), payload);
      dispatch(imageStudioActions.reset());
      //toast.success("Image generation started");
    } catch (error) {
      console.log(error);
      toast.error("Couldn't start image generation");
    }
  };

  const isDisabled = () => {
    if(!imageStudioState.prompt) return false;
    const uploading = imageStudioState.images.filter((image) => image.uploading);
    return uploading.length > 0;
  }

  return (
    <Button
      onClick={handleGenerate}
      variant="contained"
      endIcon={<AutoAwesomeIcon />}
      disabled={isDisabled()}
    >
      Generate
    </Button>
  );
}
